import { getCurrentApplicationId } from "~/lib/applicationId";

export type AdjustPlatform =
  | "RenkaAndroid"
  | "HokageIos"
  | "CarinaIos"
  | "SakuraIos"
  | "HibanaIos"
  | "CocoplusIos"
  | "CorunIos";

/** Repro・Adjust イベント送信対象のネイティブアプリ applicationId */
// 84: Sina に変換したアプリ（Sakura）。本家と同様に Repro 送信対象に含める
// 132: HIBANA。ネイティブアプリ判定漏れで通知許諾フローが発火しない不具合の修正のため追加
// 145: coco+。ネイティブアプリとして通知許諾フロー等を有効化
// 148: CORUN。iOS ネイティブアプリとして通知許諾フロー等を有効化
const NATIVE_APPLICATION_IDS = new Set([
  "76",
  "84",
  "93",
  "95",
  "132",
  "145",
  "148",
]);

export const isNativeApplication = (): boolean => {
  return NATIVE_APPLICATION_IDS.has(getCurrentApplicationId());
};

export const getCurrentAdjustPlatform = (): AdjustPlatform | null => {
  const appId = getCurrentApplicationId();
  switch (appId) {
    case "76":
      return "RenkaAndroid";
    case "93":
      return "HokageIos";
    case "95":
      return "CarinaIos";
    case "84":
      return "SakuraIos";
    case "132":
      return "HibanaIos";
    case "145":
      return "CocoplusIos";
    case "148":
      return "CorunIos";
    default:
      return null;
  }
};
